
import { Component, Vue, Watch } from 'vue-property-decorator'
import SellerHeader from '@/components/Seller/SellerHeader.vue'
import { getAllVenues, toggleActiveVenue } from '@/services/venues.service'
import { calculateTotalPages } from '@/utils/pagination/pagination.utils'
import { VenueAdmin } from '@/interfaces/admin/venues/venue-admin.interface'
import { StatusFilter } from '@/interfaces/global/paginate.interface'

@Component({
  components: { SellerHeader },
})
export default class VenueList extends Vue {
  statusFilterOptions: string[] = [StatusFilter.ALL, StatusFilter.ACTIVE, StatusFilter.INACTIVE]
  venues: VenueAdmin[] = []
  page: number = 1
  totalPages: number = 1
  statusFilter: string = StatusFilter.ALL
  filter: string = ''

  /**
   * Fetches venues based on page and status.
   */
  async getVenues(page = 1, status: string = StatusFilter.ALL) {
    try {
      const { data, meta } = await getAllVenues(page, status, this.filter)
      this.totalPages = calculateTotalPages(meta.total, meta.per_page)
      this.venues = data
    } catch (error) {
      // toast already handled in service
      console.error('Error fetching venues:', error)
    }
  }

  /**
   * Filters venues by status and text.
   */
  async filterVenues(page = 1, statusFilter: string = StatusFilter.ALL) {
    try {
      this.statusFilter = statusFilter
      await this.getVenues(page, statusFilter)
    } catch (error) {
      console.error('Error filtering venues:', error)
    }
  }

  /**
   * Toggle active state for a venue.
   */
  async onToggleStatus(value: boolean, index: number) {
    try {
      const { id, name } = this.venues[index]
      await toggleActiveVenue(id)

      this.venues[index].status = value

      this.$toast.success(
        `El venue "${name}" ha sido ${value ? 'activado' : 'desactivado'} correctamente.`
      )
    } catch (error) {
      console.error('Error toggling status:', error)
      this.$toast.error('Ocurrió un error al cambiar el estado del venue.')
    }
  }

  @Watch('page', { immediate: true, deep: true })
  onPageChange(nextPage: number) {
    this.getVenues(nextPage, this.statusFilter)
  }

  mounted() {
    this.getVenues(1, this.statusFilter)
  }
}
